import { Token } from '@/src/models';
import { BookOffersRequest } from 'xrpl';

// Convert token to XRPL currency object
const toXrplCurrency = (t: Token) =>
  t.code === 'XRP' ? { currency: 'XRP' } : { currency: t.code, issuer: t.issuer };

// Build request for book offers
export const buildRequest = (
  takerGets: Token,
  takerPays: Token,
  limit = 10
): BookOffersRequest => ({
  command: 'book_offers',
  taker_gets: toXrplCurrency(takerGets),
  taker_pays: toXrplCurrency(takerPays),
  ledger_index: 'current',
  limit,
  api_version: 2,
});
